export enum TransferSteps {
  TransferSettings = 'TransferSettings',
  TransferReview = 'TransferReview',
  TransferSMS = 'TransferSMS',
  TransferConfirmation = 'TransferConfirmation',
  TransferConcluded = 'TransferConcluded',
}
